module.exports = __webpack_public_path__ + "img/ganhemais-white.e2b7dbb6.svg";